import React, { FC } from 'react';
import cls from './FilterSubBody.module.css';
import classNames from 'classnames';
import { FilterSubBodyItem } from './FilterSubBodyItem';

export const FilterSubBody = ({ listSub }) => {
    return (
        <div className={classNames(cls.listBody)}>
            <FilterSubBodyItem guid={'all'} title={i18next.t('FilterSubBody.listBody.title')} />
            {listSub.map(({ title, guid }) => (
                <FilterSubBodyItem key={guid} guid={guid} title={title} />
            ))}
        </div>
    );
};
